/**
 * Validate the `?next=` param on the login page.
 *
 * Per the data-layer handoff §8: the `next` param must only allow paths
 * starting with `/`, never absolute URLs. Otherwise a malicious link
 * (e.g. emailed phishing link) could redirect to an attacker-controlled
 * site post-login.
 *
 * Rules:
 *   - Must start with `/`
 *   - Must NOT start with `//` (protocol-relative — those are absolute)
 *   - Must NOT contain a colon before any `/` after the first character
 *     (defense in depth against `/..\\evil.com` style edge cases on
 *     non-conforming browsers)
 */
const FALLBACK = '/pay';

export function sanitizeNext(raw: string | null | undefined): string {
  if (!raw) return FALLBACK;

  // The URLSearchParams API decodes once; if a caller is passing a
  // double-encoded string we still want the right behavior, so check both.
  const candidate = raw;

  if (!candidate.startsWith('/')) return FALLBACK;
  if (candidate.startsWith('//')) return FALLBACK;
  // Reject anything that looks like a scheme (e.g. javascript:alert).
  if (/^\/[^/]*:/.test(candidate)) return FALLBACK;

  return candidate;
}
